import Image from 'next/image'

interface LoadingStateProps {
  // No props needed for now, but interface is added for future extensibility
}

/**
 * Loading state component for ProjectSight modal
 * Shows a spinner while exporting to ProjectSight
 */
export const LoadingState: React.FC<LoadingStateProps> = () => {
  return (
    <div
      className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-12'
      aria-live='polite'
      role='status'
    >
      <Image
        src='/nextassets/images/spinner.svg'
        alt='Loading export to ProjectSight'
        width='115'
        height='115'
        role='presentation'
      />
      <p className='tw-sr-only'>Exporting to ProjectSight, please wait...</p>
    </div>
  )
}

export default LoadingState
